import { render, staticRenderFns } from "./PopupProgram.vue?vue&type=template&id=ac97000e&"
import script from "./PopupProgram.vue?vue&type=script&lang=js&"
export * from "./PopupProgram.vue?vue&type=script&lang=js&"
import style0 from "./PopupProgram.vue?vue&type=style&index=0&id=ac97000e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports